import {
  TranslationConcretingMessages,
  ConcretingMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationConcretingMessages = {
  [ConcretingMessages.todayText]: "Today",
  [ConcretingMessages.pastText]: "Previous",
  [ConcretingMessages.futureText]: "Future",
  [ConcretingMessages.trackDelivery]: "Track delivery!"
};
